export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "hemingwaynew-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "hemingwaynew-themeWrapLive" */'./LiveThemeImporter'),
  },
};
